import React from 'react'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity, View } from 'react-native'
import { styles } from './styles'
import { BtText } from '@linqpal/components/src/ui'
import { CloseLines } from '../../../../../../assets/icons'
import { observer } from 'mobx-react'

type HeaderProps = {
  closeSidebar: () => void
  title?: string | React.ReactElement
}
export const Header = observer(({ closeSidebar, title }: HeaderProps) => {
  const { t } = useTranslation('global')
  return (
    <View style={styles.header}>
      <BtText style={styles.title}>
        {title ? title : t('Projects.add_new_project')}
      </BtText>
      <TouchableOpacity
        style={styles.closeButton}
        onPress={() => closeSidebar()}
        testID="projects_view_invoice_close_button"
      >
        <CloseLines />
      </TouchableOpacity>
    </View>
  )
})
